export const LOCATION_TYPE_CODES = {
  FACTORY_LOCATION: 'factory_location',
  OFFICE_LOCATION: 'office_location',
} as const

/** Location types that are selectable in the header LocationSelector */
export const HEADER_LOCATION_TYPES = [
  LOCATION_TYPE_CODES.FACTORY_LOCATION,
  LOCATION_TYPE_CODES.OFFICE_LOCATION,
] as const

export const LOCATION_STORAGE_KEY = 'portal-selected-location'
